<template>
    <div>
        <div
            v-if="contactFormSubmitted"
            class="form-submitted-message font-bold uppercase text-gold-500 mb-8">
            {{ formLabels.formSentMessage }}
        </div>
        <form
            v-if="!contactFormSubmitted"
            @submit.prevent="submit">
            <ContactField
                v-model="form.name"
                :label="formLabels.nameLabel"
                field-name="name"
                required
            />
            <ContactField
                v-model="form.email"
                type="email"
                :label="formLabels.emailLabel"
                field-name="email"
                required
            />
            <ContactField
                v-model="form.phone"
                :label="formLabels.phoneLabel"
                field-name="phone"
                :required="false"
            />
            <ContactField
                v-model="form.message"
                type="textarea"
                :label="formLabels.messageLabel"
                field-name="message"
                required
            />
            <button
                type="submit"
                class="btn-gold btn-contact block text-sm relative max-w-sm"
                :class="{'opacity-50 cursor-not-allowed': ! submitEnabled}"
                :disabled="! submitEnabled">
                {{ formLabels.buttonLabel }}
                <svg-icon
                    icon="arrow-horizontal"
                    class="w-7 h-6 inline-block ml-3" />
            </button>
        </form>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import ContactField from '@whisper/components/contact/ContactField';

export default {
  components: {
    ContactField,
    SvgIcon,
  },
  props: {
    contactFormSubmitted: {
      type: Boolean,
    },
    formLabels: {
      type: Object,
      required: true,
    },
    postRoute: {
      require: true,
    },
  },
  data: () => ({
    form: {
      name: '',
      email: '',
      phone: '',
      message: '',
    },
  }),
  computed: {
    submitEnabled() {
      return this.form.name.length > 1 && this.form.email.length > 1 && this.form.message.length > 1;
    },
  },
  methods: {
    submit() {
      this.$inertia.post(this.postRoute, this.form, {
        preserveScroll: true,
      });
    },
  },
};
</script>

<style scoped>

</style>
